var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 13.3335L7.15547 9.51201C7.80635 8.86113 8.86162 8.86113 9.5125 9.51201L13.334 13.3335M11.6673 11.6668L12.9888 10.3453C13.6397 9.69447 14.695 9.69447 15.3458 10.3453L16.6673 11.6668M11.6673 6.66683H11.6757M5.00065 16.6668H15.0007C15.9211 16.6668 16.6673 15.9206 16.6673 15.0002V5.00016C16.6673 4.07969 15.9211 3.3335 15.0007 3.3335H5.00065C4.08018 3.3335 3.33398 4.07969 3.33398 5.00016V15.0002C3.33398 15.9206 4.08018 16.6668 5.00065 16.6668Z",
    stroke: "#141414",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageType);
export default __webpack_public_path__ + "static/media/ImageType.37146ed3f7fe8ef3af3d92bb69a5a76d.svg";
export { ForwardRef as ReactComponent };